import * as React from 'react'
import { cn } from '#app/utils/misc.tsx'
import { Skeleton } from './skeleton.tsx'
export type ImageProps = JSX.IntrinsicElements['img']

export const Image: React.FC<ImageProps> = (props: ImageProps) => {
	const [realSrc, setRealSrc] = React.useState('')
	const [loaded, setLoaded] = React.useState(false)

	React.useEffect(() => {
		// @ts-ignore
		let img = new window.Image()
		if (props.src) {
			img.src = props.src ?? ''
			img.onload = () => {
				setLoaded(true)
				setRealSrc(props.src ?? '')
			}
		}
	}, [props.src])

	if (!loaded) {
		return <Skeleton className={cn(props.className, 'border-none')} />
	}

	return <img {...props} src={realSrc} alt={props.alt} />
}
